export default "__VITE_ASSET__DYbiQ85w__"